import getPublicAssetUrl from "utils/PublicAsset";

type AvatarProps = {
    src: string;
    isReady?: boolean;
    className?: string;
};

const Avatar = ({ src, className = "" }: AvatarProps) => (
    <div className={`avatar-ring rounded-full shadow-md ${className}`}>
        <div className="avatar-inner-ring w-full h-full rounded-full">
            <div className="avatar-image w-full h-full rounded-full overflow-hidden">
                <img src={src.startsWith("/assets/") ? getPublicAssetUrl(src) : src} alt="" className="w-full h-full object-cover" draggable={false} />
            </div>
        </div>
    </div>
);

export default Avatar;
